import React, { useEffect, useState } from "react";
import Card from "../components/Card";
import "./Contact.css";
import emailjs from '@emailjs/browser';
import { useInView } from "react-intersection-observer";
import { motion, useAnimation } from "framer-motion";

function Contact() {
  const [displayForm, setDisplayForm] = useState(false);
  const [messagePrompt, setMessagePrompt] = useState(false)
  const [fields, setFields] = useState({
    name: "",
    email: "",
    message: "",
  });

  const { ref, inView } = useInView();
  const contactCard = useAnimation()
  const contactHead = useAnimation()

  useEffect(() => {
     if(inView){
       contactHead.start({
         opacity: 1,
         transition: {delay: 0.5, ease: "easeInOut"}
       })
       contactCard.start({
         opacity: 1,
         transition: {delay: 0.8, ease: "easeInOut"}
       })
     }else if(!inView){
      contactHead.start({
        opacity: 0,
      })
      contactCard.start({
        opacity: 0
      })
    }
  },[inView, contactCard, contactHead])

  const inputHandler = (e) => {
    e.preventDefault();
    const { name } = e.target;
    const { value } = e.target;

    setFields((pre) => {
      return {
        ...pre,
        [name]: value,
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log(fields)
    emailjs.send('service_vzag8qq', 'template_qbyfx9l', fields, 'jsYjg_66kJfYaUwQa')
      .then((result) => {
          setFields({name:'', email: '', message: ''})
          setMessagePrompt(true)
         setTimeout(() => {
          setMessagePrompt(false)
          setDisplayForm(false)
         }, 1500);
      }, (error) => {
          console.log(error.text);
      });
  }

  return (
    <div ref={ref} id="contact" className={`contact`}>
      <div className="contact__wrapper">
        <motion.div animate={contactHead} className="contact__header">
          <hr className="hr__line1" />
          <h2>Contact me</h2>
          <hr className="hr__line2" />
        </motion.div>
        <motion.div animate={contactCard} className="contactDetail__wrapper">
          <div className="contactDetail__align">
            <div className="contact__header">
              <h4>Thank You for visiting!</h4>
            </div>
            <div className="contact__para">
              <p>
                If you are interested or need a talk. Don't
                hesitate to say Hi!
              </p>
            </div>
            <div>
              <button
                className="btn__grad"
                onClick={() => setDisplayForm(true)}
              >
                Say Hello
              </button>
            </div>
          </div>
        </motion.div>
        {displayForm && (
          <div className="form__container">
            <Card className="form__wrapper">
            <div className="btnClose__wrapper">
            <button
              className="btn__close"
              onClick={() => setDisplayForm(false)}
            >
              X
            </button>
          </div>
              <div className="message__success">{messagePrompt && <h5>✔ Message Sent</h5>}</div>
              <Card className="form__align">
                <form onSubmit={handleSubmit}>
                  <input
                    type="text"
                    onChange={inputHandler}
                    name="name"
                    value={fields.name}
                    placeholder="Name"
                    required
                  />
                  <input
                    type="email"
                    onChange={inputHandler}
                    name="email"
                    value={fields.email}
                    placeholder="Email"
                    required
                  />
                  <textarea
                    onChange={inputHandler}
                    name="message"
                    value={fields.message}
                    placeholder="Message.."
                    required
                  />
                  <button type="submit" className="btn__submit">
                    SEND 
                  </button>
                </form>
              </Card>
            </Card>
          </div>
        )}
      </div>
    </div>
  );
}

export default Contact;
